import React, { PropsWithChildren, useEffect } from "react";

import styles from './styles.module.scss';

interface BaseModalProps {
    show: boolean;
    setShow: (show: boolean) => void;
    children: React.ReactNode;
}

export default function BaseModal({
    show,
    setShow,
    children,
}: PropsWithChildren<BaseModalProps>) {
    useEffect(() => {
        if (show) {
            document.body.style.overflow = 'hidden';
        }
    }, [show])

    const handleCloseModal = () => {
        setShow(false);
        document.body.style.removeProperty('overflow');
    }

    if (!show) return null;

    return (
        <div className={styles.baseModal} onClick={handleCloseModal}>
            <div className={styles.card} onClick={(e) => e.stopPropagation()}>
                <div className={styles.close}>
                    <button onClick={handleCloseModal} className={styles.closeButton}>
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            strokeWidth={2} 
                            className={styles.closeIcon}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
}